import script from "./commissionView.vue?vue&type=script&setup=true&lang=ts"
export * from "./commissionView.vue?vue&type=script&setup=true&lang=ts"

import "./commissionView.vue?vue&type=style&index=0&id=136cb022&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-136cb022"]])

export default __exports__